import { render, staticRenderFns } from "./ScaleInput.vue?vue&type=template&id=8cb5b088&scoped=true&"
import script from "./ScaleInput.vue?vue&type=script&lang=js&"
export * from "./ScaleInput.vue?vue&type=script&lang=js&"
import style0 from "./ScaleInput.vue?vue&type=style&index=0&id=8cb5b088&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb5b088",
  null
  
)

export default component.exports